(() => {
  const manager = document.querySelector('wishlist-manager');
  if (!manager) return;

  const authenticated = manager.dataset.authenticated === 'true';
  const storageKey = `vunoti:wishlist:${manager.dataset.customerKey}`;
  const dialog = manager.querySelector('[data-wishlist-login-dialog]');
  const liveRegion = manager.querySelector('[data-wishlist-live-region]');

  const readItems = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value : [];
    } catch {
      return [];
    }
  };

  const writeItems = (items) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(items));
    } catch {
      return;
    }
    window.dispatchEvent(new CustomEvent('vunoti:wishlist-updated', { detail: { items } }));
  };

  const announce = (message) => {
    if (!liveRegion) return;
    liveRegion.textContent = '';
    window.setTimeout(() => { liveRegion.textContent = message; }, 30);
  };

  const openLogin = () => {
    if (dialog?.showModal) dialog.showModal();
    else window.location.href = dialog?.querySelector('a')?.href || '/account/login';
  };

  const updateButtons = (items = readItems()) => {
    const ids = new Set(items.map((item) => String(item.id)));
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const selected = ids.has(String(button.dataset.productId));
      button.setAttribute('aria-pressed', String(selected));
      const label = button.querySelector('[data-wishlist-label]');
      if (label) label.textContent = selected ? manager.dataset.removeLabel : manager.dataset.addLabel;
    });
  };

  const productFromButton = (button) => ({
    id: button.dataset.productId,
    handle: button.dataset.productHandle,
    title: button.dataset.productTitle,
    url: button.dataset.productUrl,
    image: button.dataset.productImage,
    price: button.dataset.productPrice
  });

  const toggleProduct = (button) => {
    const product = productFromButton(button);
    const items = readItems();
    const index = items.findIndex((item) => String(item.id) === String(product.id));
    if (index >= 0) {
      items.splice(index, 1);
      announce(manager.dataset.removedMessage);
    } else {
      items.unshift(product);
      announce(manager.dataset.addedMessage);
    }
    writeItems(items);
    updateButtons(items);
  };

  const renderWishlistPage = () => {
    const page = document.querySelector('[data-wishlist-page]');
    if (!page || !authenticated) return;
    const grid = page.querySelector('[data-wishlist-grid]');
    const empty = page.querySelector('[data-wishlist-empty]');
    const items = readItems();
    grid.replaceChildren();
    empty.hidden = items.length > 0;
    grid.hidden = items.length === 0;

    items.forEach((item) => {
      const card = document.createElement('article');
      card.className = 'vunoti-wishlist-card';
      const link = document.createElement('a');
      link.href = item.url;
      link.className = 'vunoti-wishlist-card__media';
      link.setAttribute('aria-label', item.title);
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.title;
        image.loading = 'lazy';
        link.append(image);
      }
      const content = document.createElement('div');
      content.className = 'vunoti-wishlist-card__content';
      const title = document.createElement('h2');
      const titleLink = document.createElement('a');
      titleLink.href = item.url;
      titleLink.textContent = item.title;
      title.append(titleLink);
      const price = document.createElement('p');
      price.textContent = item.price;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'vunoti-wishlist-card__remove';
      remove.textContent = manager.dataset.removeLabel;
      remove.addEventListener('click', () => {
        const next = readItems().filter((saved) => String(saved.id) !== String(item.id));
        writeItems(next);
        announce(manager.dataset.removedMessage);
      });
      content.append(title, price, remove);
      card.append(link, content);
      grid.append(card);
    });
  };
  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-wishlist-dialog-close]');
    if (closeButton) {
      dialog?.close();
      return;
    }

    const gatedLink = event.target.closest('[data-wishlist-auth-gated]');
    if (gatedLink && !authenticated) {
      event.preventDefault();
      openLogin();
      return;
    }

    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (!toggle) return;
    event.preventDefault();
    event.stopPropagation();
    if (!authenticated) {
      openLogin();
      return;
    }
    toggleProduct(toggle);
  });

  window.addEventListener('vunoti:wishlist-updated', (event) => {
    updateButtons(event.detail.items);
    renderWishlistPage();
  });
  updateButtons();
  renderWishlistPage();
})();
